import * as React from "react"
import { Link } from "gatsby"
import { css } from "@emotion/react"
import { useIntl } from "gatsby-plugin-react-intl"
import { device } from "../styles/device"

export function GoToCheckOut({ variantId, quantity, available, ...props }) {
    const intl = useIntl()

    return (
        <Link aria-label={`Shopping Cart`} to="/cart">
            <button type="submit" css={button}>
                {intl.formatMessage({ id: "checkout" })}
            </button>
        </Link>
    )
}

const button = css`
    font-size: 1.33rem;
    width: 300px;
    padding: 1.4rem 0;
    color: black;
    background: white;
    border: solid 1px black;
    border-radius: none;
    cursor: pointer;
    margin-top: 30px;
    &:hover {
        background: black;
        color: white;
        border: solid 1px black;
    }

    @media ${device.tb} {
        width: 30vw;
    }

    @media ${device.sp} {
        font-size: 1.55rem;
        width: 80vw;
        padding: 2rem 0;
    }
`
